// | ------------------------------------------------------------------------
// | Components - Shop - Quantity Inputs
// | ------------------------------------------------------------------------ 


window.addEventListener('load', (event) => {

	var plusBtn = document.querySelectorAll(".plus-btn");
	var minusBtn = document.querySelectorAll(".minus-btn");

	for(var i =0; i< plusBtn.length; i++){

		plusBtn[i].onclick = function(){

			var quantInput = this.previousElementSibling;

			quantInput.value = parseInt(quantInput.value) + 1;

			if (quantInput.value >= parseInt(9999)) {
				quantInput.value = 9999;
			}	

		}

	}

	for(var i =0; i< minusBtn.length; i++){

		minusBtn[i].onclick = function(){

			var quantInput = this.nextElementSibling;

			quantInput.value = parseInt(quantInput.value) - 1;

			if (quantInput.value <= parseInt(0)) {
				quantInput.value = 0;
			}

		}

	}	

});